import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../state/store';
import { useMemo } from 'react';
import {
    InvoiceApiParams,
    InvoiceType,
    mapAppIdentToInvoiceType,
    mapInvoiceTypeToApiParams,
    mapViewComponentToInvoiceType,
} from '../../../../shared/invoice/invoiceConfig';

/**
 * Hook that retrieves selectedApp from Redux and maps its appIdent to InvoiceType enum and API params
 * @returns Object containing InvoiceType enum value and API params based on the current selectedApp's appIdent
 */
export const useInvoiceWrapperApp = (viewComponent?: string): { invoiceType: InvoiceType; apiParams: InvoiceApiParams } => {
    const { t } = useTranslation('invoice');
    const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedApp);
    const appIdent = selectedApp?.appIdent || '';
    const invoiceType = useMemo(() => {
        const invoiceTypeFromView = viewComponent ? mapViewComponentToInvoiceType(viewComponent) : InvoiceType.UNKNOWN;
        return invoiceTypeFromView !== InvoiceType.UNKNOWN ? invoiceTypeFromView : mapAppIdentToInvoiceType(appIdent);
    }, [appIdent, viewComponent]);

    const apiParams = useMemo(() => {
        return mapInvoiceTypeToApiParams(invoiceType, (key: string) => t(`invoice_filters.${key}`, { ns: 'invoice' }));
    }, [invoiceType, t]);

    return { invoiceType, apiParams };
};

